import { v4 as uuidv4 } from 'uuid';
import { createTheme } from '@mui/material';
import colors from '../../../../scss/colors';

const addToIndustries = (newItems, formIndustries) => {
  formIndustries = [];
  newItems.forEach((industry) => {
    formIndustries.push({
      Industry: {
        Id: industry.IndustryId,
        Name: industry.value
      },
      IndustryId: industry.IndustryId,
      label: industry.value,
      value: industry.value
    });
  });

  return formIndustries;
};

const addToFunctions = (newItems, formFunctions) => {
  formFunctions = [];
  newItems.forEach((jobFunction) => {
    formFunctions.push({
      JobFunction: {
        Id: jobFunction.JobFunctionId,
        Name: jobFunction.value
      },
      JobFunctionId: jobFunction.JobFunctionId,
      label: jobFunction.value,
      value: jobFunction.value
    });
  });

  return formFunctions;
};

const isSkillUnique = (newItem, skillsArray) =>
  !skillsArray.find((item) =>
    typeof newItem === 'string' ? item.SkillName === newItem : item.SkillName === newItem.props.label
  );

const addToSkills = (newItemsArray, stringItem, formSkills) => {
  const skillsArray = Array.isArray(formSkills)
    ? formSkills
    : Object.values(formSkills).filter(item => typeof item === 'object' && item.SkillName)

  if (newItemsArray && newItemsArray.length) {
    newItemsArray.forEach((skill) => {
      if (isSkillUnique(skill, skillsArray))
        skillsArray.push({
          SkillName: skill.props.label,
          Name: skill.props.label,
          Id: uuidv4(10),
          TopSkill: false
        });
    });
  }

  if (isSkillUnique(stringItem, skillsArray) && stringItem)
    skillsArray.push({
      SkillName: stringItem,
      Name: stringItem,
      Id: uuidv4(20),
      TopSkill: false
    });

  return skillsArray;
};

const theme = createTheme({
  palette: {
    primary: {
      main: colors.MEDIUM_GREY_V2
    }
  },
  color: 'white'
});

export { addToIndustries, addToFunctions, addToSkills, isSkillUnique, theme };
